import { Localized } from "@fluent/react"
import { Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { useCallback, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { URSRequirement, Urs } from "./UrsSlice"
import { selectAllURSComments, selectURSComments, URSComment } from "./URSCommentSlice"
import { CommentsDialog } from "./Comments"
import { selectLoggedUser } from "../user/userSlice"
import { AppBlockGeneric, AppRowGeneric } from "../ursOffer/importedUrsSlice"
import { BlockMeta } from "./ImportedSupplierUrsPreview"

export interface ImportedRequirementsPanelProps {
    urs: Urs
    template: boolean
}
export const NoRequirements = () => {
    return <Typography gutterBottom component="div" color="textSecondary" variant="h5">
        <Localized id="urs-no-requirements">Brak wymagań.</Localized>
    </Typography>
}
type DialogState =
    | { tag: 'none' }
    | { tag: 'comments', requirement: URSRequirement }

export const ImportedRequirementsFlatPanel = ({ urs, template }: ImportedRequirementsPanelProps) => {
    const { id: ursId } = urs
    const dispatch = useAppDispatch()
    const user = useAppSelector(selectLoggedUser)
    const canUpload = urs.links.save !== undefined
    const { deviceTypeId } = urs
    const [dialog, setDialog] = useState<DialogState>({ tag: 'none' })
    const comments = useAppSelector(state => {
        if (selectURSComments(state).ursId === ursId) {
            return selectAllURSComments(state)
        } else {
            return []
        }
    })

    // CALLBACKs
    const handleHideDialog = useCallback(() => setDialog({ tag: 'none' }), [])
    const userCanSendComment = useCallback(() => {
        return false
    }, [urs])
    const userCanApproveComment = useCallback(() => {
        return false
    }, [urs])
    const userCanEditComment = useCallback((comment: URSComment) => {
        return false
    }, [urs, user])

    // CALLBACKs

    const ursRequirements = urs.types[0].requirements
    let blocks: AppBlockGeneric<URSRequirement>[] = []
    let metas: BlockMeta[] = []
    for (let i = 0; i < ursRequirements.length; i++) {
        const r = ursRequirements[i]
        const { jsonContent } = r
        if (jsonContent) {
            const meta: BlockMeta = JSON.parse(jsonContent) as BlockMeta
            console.log(`meta`)
            console.log(meta)
            console.log(metas.length)
            console.log(i)
            switch (meta.type) {
                case 'h':
                    blocks.push({
                        type: 'h',
                        content: meta.content,
                        data: r,
                    })
                    break
                case 'p':
                    blocks.push({
                        type: 'p',
                        content: meta.content,
                        data: r,
                    })
                    break
                case 'ol':
                    blocks.push({
                        type: 'ol',
                        items: r.childRequirements.map(childReq => {
                            return {
                                content: childReq.name,
                                data: childReq,
                            }
                        }),
                        data: r,
                    })
                    break
                case 'ul':
                    blocks.push({
                        type: 'ul',
                        items: r.childRequirements.map(childReq => {
                            return {
                                content: childReq.name,
                                data: childReq,
                            }
                        }),
                        data: r,
                    })
                    break
                case 'th':
                case 'tr':
                    if (i > 0 && metas.length > 0) {
                        const prev = metas[i-1]
                        if ((prev.type === 'th' || prev.type === 'tr') && prev.tableId === meta.tableId) {
                            const tab = blocks[blocks.length-1]
                            if (tab.type === 'table') {
                                tab.rows.push({
                                    type: meta.type,
                                    cols: meta.cols,
                                    plain: r.name,
                                    data: r,
                                    split: meta.split,
                                })
                            } else {
                                console.log("[BUG] expected 'table'")
                            }
                        } else {
                            blocks.push({
                                type: 'table',
                                colsCount: meta.cols.length,
                                rows: [{
                                    type: meta.type,
                                    cols: meta.cols,
                                    plain: r.name,
                                    data: r,
                                    split: meta.split,
                                }]
                            })
                        }
                    } else {
                        blocks.push({
                            type: 'table',
                            colsCount: meta.cols.length,
                            rows: [{
                                type: meta.type,
                                cols: meta.cols,
                                plain: r.name,
                                data: r,
                                split: meta.split,
                            }]
                        })
                    }
                    break
            }
            metas.push(meta)
        }
    }

    return <Container component={Paper} sx={{
        height: 'calc(100vh - 300px)',
        overflow: 'auto',
    }} maxWidth='lg'>
        {blocks.map((b, i) => <RenderBlock block={b} />)}
        {dialog.tag === 'comments' && <CommentsDialog
            comments={comments}
            ursId={ursId}
            requirement={dialog.requirement}
            onClose={handleHideDialog}
            isCommentEnabled={userCanSendComment}
            isResolvingEnabled={userCanApproveComment}
            isEditEnabled={userCanEditComment}
        />}
    </Container>
}

const RenderBlock = (props: { block : AppBlockGeneric<URSRequirement> }) => {
    const { block } = props
    switch (block.type) {
        case 'h':
            return <Typography variant="h6">
                <div dangerouslySetInnerHTML={{ __html: block.content }}></div></Typography>
        case 'p':
        return <Typography variant="body1">
                <div dangerouslySetInnerHTML={{ __html: block.content }}></div>
            </Typography>
        case 'table':
            return <AppTable colsCount={block.colsCount} rows={block.rows} />
        case 'ul':
            return <ul>
                {block.items.map(i => <li dangerouslySetInnerHTML={{ __html: i.content }}></li>)}
            </ul>
        case 'ol':
            return <ol>
                {block.items.map(i => <li dangerouslySetInnerHTML={{ __html: i.content }}></li>)}
            </ol>
    }
}

function AppTable(props: { colsCount: number, rows: AppRowGeneric<URSRequirement>[] }) {
    const { colsCount, rows } = props
    const firstTrIdx = rows.findIndex(r => r.type === 'tr')
    const ths = rows.slice(0, firstTrIdx)
    const trs = rows.slice(firstTrIdx)
    return <TableContainer sx={{
        my: 1,
    }} component={Paper}>
        <Table>
            {ths.length > 0 && <TableHead>
                {ths.map(row => <TableRow>
                    {row.cols.map(col => <TableCell sx={{ minWidth: '150px' }}><span dangerouslySetInnerHTML={{ __html: col}}></span></TableCell>)}
                </TableRow>)}
            </TableHead>}
            <TableBody>
                {trs.map(row => <TableRow>
                    {row.cols.map(col => <TableCell>
                        <p dangerouslySetInnerHTML={{ __html: col }}></p>
                    </TableCell>)}
                </TableRow>)}
            </TableBody>
        </Table>
    </TableContainer>;
}
